import FooterSocialsSection from "./FooterSocialsSection";

export default FooterSocialsSection;
